import { AlertConfigBuilder } from "shared/utils/alert-config-builder";
import { IAddNewAgencyFormContent } from "./components/AddNewAgencyFormContent";

export interface IAddNewAgentPageContent extends IAddNewAgencyFormContent {
  header: string;
  close: string;
  formDescription: string;
  cancelAdd: string;
  saveAgency: string;
  cancelAddWarning: ICancelNewAgencyAddWarningPopup;
}
export const IAddAgencyFormContentKeys = [
  "form",
  "validation",
  "help",
  "header",
  "close",
  "formDescription",
  "cancelAdd",
  "saveAgency",
  "cancelAddWarning",
];

interface ICancelNewAgencyAddWarningPopup {
  cancellationWarningHeader: string;
  cancellationWarningDescription: string;
  cancellationWarningContinueButton: string;
  cancellationWarningCloseButton: string;
}

declare type CancelAddWarningPopupSetting = {
  content: ICancelNewAgencyAddWarningPopup;
  continueCanceling: () => void;
  closePopup: () => void;
};

export function getCancelAddWarningPopup(
  setting: CancelAddWarningPopupSetting
) {
  const { content, closePopup, continueCanceling } = setting;

  return new AlertConfigBuilder()
    .initBuildEntity()
    .setDefaultContent({
      title: content.cancellationWarningHeader,
      description: content.cancellationWarningDescription,
      closeButtonText: content.cancellationWarningCloseButton,
      closePopupButtonText: content.cancellationWarningCloseButton,
    })
    .setAlertProps({ icon: "notice" })
    .setCloseButton({ type: "secondary", click: continueCanceling })
    .addButton({
      type: "primary",
      click: closePopup,
      name: content.cancellationWarningContinueButton,
    })
    .build();
}
